import React, { useState, useEffect } from 'react'
import firebase from 'firebase'
import axios from 'axios'
import moment from 'moment'

const AddItemForm = () => {
  const [name, setName] = useState('')
  const [town, setTown] = useState('3550308')
  const [phone, setPhone] = useState('')
  const [music1, setMusic1] = useState('')
  const [music2, setMusic2] = useState('')
  const [message, setMessage] = useState('')
  const [chooseSong, setChooseSong] = useState('')
  const [listSongs, setListSongs] = useState([])
  const [saveSuccess, setSaveSuccess] = useState(false)
  const [ufList, setUfList] = useState([])
  const [uf, setUf] = useState('35')
  const [townList, setTownList] = useState([])

  useEffect(() => {
    axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
      .then(res => {
        res.data.sort((a, b) => {
          if (a.nome > b.nome) {
            return 1
          }
          if (a.nome < b.nome) {
            return -1
          }

          return 0
        })
        setUfList(res.data)
      })
  }, [])

  useEffect(() => {
    getTownList('35')
  }, [])

  const getTownList = (uf) => {
    axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`)
      .then(res => {
        setTownList(res.data)
      }
    )
  }

  const onSubmit = e => {
    e.preventDefault()
    setSaveSuccess(false)
    firebase
      .firestore()
      .collection('casamentokaju')
      .add({
        show: false,
        time: moment().valueOf(),
        name,
        uf: ufMount(),
        town: townMount(),
        phone,
        music1,
        music2,
        message
      })
      .then(() => setName(''),
                  setUf('35'),
                  setTown('3550308'),
                  setPhone(''),
                  setMusic1(''),
                  setMusic2(''),
                  setMessage(''),
                  setSaveSuccess(true))
  }

  const ufMount = () => {
    const currentUF = ufList.find(
      el => (
      el.id === Number(uf)
    ))
    return {
      uf: currentUF.sigla,
      id: currentUF.id
    }
  }

  const townMount = () => {
    const currentTown = townList.find(
      el => (
      el.id === Number(town)
    ))
    return {
      town: currentTown.nome,
      id: currentTown.id
    }
  }

  const onChooseSong = (value, option) => {
    if (option === 'music2') {
      setMusic2(value)
    } else {
      setMusic1(value)
    }

    axios.get(`https://api.vagalume.com.br/search.excerpt?q=${value}&limit=10`)
      .then(res => {
        setListSongs(res.data.response.docs)
        setChooseSong(option)
      })
  }

  const onSongClick = (music, option) => {
    if (option === 'music2') {
      setChooseSong('')
      return setMusic2(music)
    }
    setChooseSong('')
    setMusic1(music)
  }

  const renderList = (song, option) => {
    const music = `${song.title} - ${song.band}`
    return (
      <li key={song.id} ><button onClick={() => onSongClick(music, option)}>{music}</button></li>
    )
  }

  const renderSuccessSave = () => {
    return (
      <p className='save-success'>Sua mensagem foi enviada com sucesso ♥. Agradecemos o carinho!</p>
    )
  }

  const renderUfList = uf => {
    return (
      <option
        value={uf.id}
        key={uf.id}
      >{uf.sigla}</option>
    )
  }

  const renderTownList = town => {
    return (
      <option
        value={town.id}
        key={town.id}
      >{town.nome}</option>
    )
  }

  const onChangeUf = e => {
    getTownList(e.target.value)
    setUf(e.target.value)
  }

  return (
    <form onSubmit={onSubmit} className='form'>
      {saveSuccess && renderSuccessSave()}
      <label>
        <input
          placeholder='Nome Completo'
          value={name}
          name='name'
          onChange={e => setName(e.currentTarget.value)}
          required
          type='text'
        />
      </label>
      <label>
        <input
          placeholder='Whatsapp (Telefone)'
          value={phone}
          name='phone'
          required
          onChange={e => setPhone(e.currentTarget.value)}
          type='tel'
        />
      </label>
      <label className='ufLabel'>
        <select
          value={uf}
          onBlur={() => {}}
          onChange={e => onChangeUf(e)}
          name='uf'
        >
          {ufList.map(uf => renderUfList(uf))}
        </select>
      </label>
      <label className='cityLabel'>
        <select
          value={town}
          onBlur={() => {}}
          onChange={e => setTown(e.target.value)}
          name='town'
        >
          {townList.map(town => renderTownList(town))}
        </select>
      </label>
      <label>
        <input
          placeholder='1ª Opção de Música'
          value={music1}
          name='music1'
          onChange={(e) => onChooseSong(e.currentTarget.value, 'music1')}
          type='text'
          autoComplete='off'
        />
        {chooseSong === 'music1' ? (
          <ul className='select-song'>
            {listSongs && listSongs.map(song => renderList(song, 'music1'))}
          </ul>
        ) : null}
      </label>
      <label>
        <input
          placeholder='2ª Opção de Música'
          value={music2}
          name='music2'
          onChange={(e) => onChooseSong(e.currentTarget.value, 'music2')}
          type='text'
          autoComplete='off'
        />
        {chooseSong === 'music2' ? (
          <ul className='select-song'>
            {listSongs && listSongs.map(song => renderList(song, 'music2'))}
          </ul>
        ) : null}
      </label>
      <label>
        <textarea
          placeholder='Mensagem aos Noivos'
          value={message}
          name='message'
          onChange={e => setMessage(e.currentTarget.value)}
        />
      </label>
      <button>Enviar</button>
    </form>
  )
}
export default AddItemForm



// WEBPACK FOOTER //
// ./src/components/AddItemForm.js